export const DefaultProps = {
    slicer: {
        default: Infinity
    },
    contentType: {
        default: 'post',
    },
    pauseIfCategoryNotFound: {
        default: true,
    },
    contentCategory: {
        default: null
    },
    paginate: {
        default: false,
    },
    categoryPanel: {
        default: false,
    },
    flatCategoriesShape:{
        default: false,
    }
}